import React from "react";
import { PAY_STATUS_META } from "@/lib/api";

const T = {
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  progress: "bg-sky-50 text-sky-700 border-sky-200",
  served: "bg-emerald-50 text-emerald-700 border-emerald-200",
  failed: "bg-red-50 text-red-700 border-red-200",
};

export function PayBadge({ status }) {
  const m = PAY_STATUS_META[status] || { label: status, tone: "pending" };
  return (
    <span
      data-testid={`pay-badge-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-semibold ${T[m.tone]}`}
    >
      {m.label}
    </span>
  );
}
